import { CancelledContractModel } from '@models/ContractCancellation';
import { createReducer } from '@common/redux-utils';
import {
  AccountingActionType,
  SetCancelledContractsListAction,
  SetQueryAndDisbursedAction,
  SetAccountingOwnershipAction
} from './accounting.actions';

export interface AccountingState {
  readonly query: string | null;
  readonly pageNumber: number;
  readonly pageSize: number;
  readonly pageCount: number;
  readonly orderBy: string;
  readonly message: string;
  readonly loading: boolean;
  readonly filterByDisbursed: boolean;
  readonly cancelledContractsList: Array<CancelledContractModel>;
}

export const initialAccountingState: AccountingState = {
  query: '',
  pageNumber: 0,
  pageSize: 10,
  pageCount: 10,
  orderBy: '',
  message: '',
  loading: false,
  filterByDisbursed: false,
  cancelledContractsList: []
};

function handleSetQueryAndDisbursed(state: AccountingState, action: SetQueryAndDisbursedAction): AccountingState {
  return {
    ...state,
    query: action.query,
    filterByDisbursed: action.filterByDisbursed,
    orderBy: action.orderBy,
    pageNumber: action.pageNumber,
    pageSize: action.pageSize,
    loading: true
  };
}

function handleSetCancelledContractsList(
  state: AccountingState,
  action: SetCancelledContractsListAction
): AccountingState {
  return {
    ...state,
    cancelledContractsList: action.results.results,
    pageCount: action.results.totalResults <= 0 ? 0 : Math.ceil(action.results.totalResults / action.results.pageSize),
    loading: false
  };
}

function handleSetAccountingOwnership(state: AccountingState, action: SetAccountingOwnershipAction): AccountingState {
  const newCancelledContractsList = state.cancelledContractsList
    .filter(x => x.cancellationId !== action.cancelledContract.cancellationId)
    .concat([action.cancelledContract]);

  return {
    ...state,
    cancelledContractsList: newCancelledContractsList
  };
}

export const AccountingReducer = createReducer<AccountingState, AccountingActionType>(initialAccountingState, {
  [AccountingActionType.SetQueryAndDisbursed]: handleSetQueryAndDisbursed,
  [AccountingActionType.SetCancelledContractsList]: handleSetCancelledContractsList,
  [AccountingActionType.SetAccountingOwnership]: handleSetAccountingOwnership
});



// WEBPACK FOOTER //
// ./src/accounting/accounting.reducer.ts